import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = (props: ToasterProps) => {
  return (
    <Sonner
      // Spread FIRST: the branding below must win — a caller passing its own
      // toastOptions would otherwise silently replace the whole block.
      {...props}
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      // Sonner ships its own font stack and a black default action chip —
      // both off-brand. Force the app font and restyle the action/cancel
      // buttons to the Ambr accent (Jamie, 29 Jul).
      toastOptions={{
        classNames: {
          toast: "!font-sans",
          title: "!font-medium",
          actionButton:
            "!bg-brand-accent hover:!bg-brand-accent-hover !text-white !font-medium !rounded-md",
          cancelButton: "!bg-surface-alt !text-copy-mid !rounded-md",
        },
      }}
      style={
        {
          "--normal-bg": "hsl(var(--popover))",
          "--normal-text": "hsl(var(--popover-foreground))",
          "--normal-border": "hsl(var(--border))",
          "--border-radius": "var(--radius)",
          fontFamily: "var(--font-sans)",
        } as React.CSSProperties
      }
    />
  )
}

export { Toaster }
